import { useNavigate, useOutletContext } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import Personal from 'modules/employees/components/Personal'
import NewPersonal from 'modules/employees/components/Personal/NewPersonal'
import { RouteContext } from 'modules/employees/lib/types'

const PersonalPage = () => {
  const { employee, canSeePersonalInfo, loading } = useOutletContext<RouteContext>()

  const hasNewDesign = hasFeature('dev_employees_new_profile')
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useEffect(() => {
    // it can also be null if it's still loading the permission
    // that's why we check for false specifically
    if (!canSeePersonalInfo && !loading) {
      // Return to the employee profile in case the user doesn't have permission
      // to see the personal info.
      // This can happen if you navigate directly to /personal with your browser.
      navigate(navigation.employees.id.fullPath({ id: employee.attributes.id }))
    }
  }, [canSeePersonalInfo, employee.attributes.id, loading])

  return (
    <>
      {!hasNewDesign && <Personal contractVersions={contractVersions} />}
      {hasNewDesign && <NewPersonal contractVersions={contractVersions} />}
    </>
  )
}

export default PersonalPage
